import { type PlanOrganizationTask, PlanOrganizationTaskName, PlanOrganizationTaskStatus } from '../../../models/PlanOrganizationTask'
import { DataTool } from './DataTool'

interface Props {
  planOrganizationTasks: PlanOrganizationTask[]
}
export const FocusStudentDataTool = (props: Props): JSX.Element => {
  const instructionsURL = 'https://www.gvsu.edu/autismcenter/2025-2026-rcn-application-and-contract-forms-595.htm'
  const focusStudentDataBOYTask = props.planOrganizationTasks.find(t => t.taskName === PlanOrganizationTaskName.FocusStudentDataBOY)
  const focusStudentDataEOYTask = props.planOrganizationTasks.find(t => t.taskName === PlanOrganizationTaskName.FocusStudentDataEOY)

  return (
    <DataTool
      planOrganizationTaskId={focusStudentDataBOYTask?.id ?? 0}
      completed={focusStudentDataBOYTask?.status === PlanOrganizationTaskStatus.UpdatesSubmitted}
      title='Focus Student Data'
      dueDate={focusStudentDataEOYTask?.dueDate ?? new Date()}
      descriptor='Beginning of Year'
      secondaryPlanOrganizationTaskId={focusStudentDataEOYTask?.id ?? 0}
      secondaryCompleted={focusStudentDataEOYTask?.status === PlanOrganizationTaskStatus.UpdatesSubmitted}
      secondaryDescriptor='End of Year'
      showDescriptors
      instructionsUrl={instructionsURL}
      color='var(--green-700)'
      successMessage='Focus Student Data Updated'
      dataTestId='focusStudentDataTool'
    />
  )
}
